// extracted by mini-css-extract-plugin
export default {"connectSuccessContainer":"style_connectSuccessContainer__w5wGx","body":"style_body__ZWHRw","title":"style_title__tTdOg","submitButton":"style_submitButton__BNXEQ"};